module.exports = __webpack_public_path__ + "img/icon_dualpower.d473d379.png";